module.exports = __webpack_public_path__ + "img/icon_warning.ef3c4c63.svg";